import { gql } from '@apollo/client'

export const GET_TPLACE = gql`
  query GetTplace($placeId: UUID!) {
    tplace(input: { id: $placeId }) {
      id
      area
      code
      name
      param
      tags
      type
      parent {
        id
      }
      coordinates {
        latitude
        longitude
      }
      geofenceRadius
      address {
        line1
        line2
        cityName
        stateCode
        zipCode
        countryCode
      }
      amenities
      directions
      company {
        id
        name
        vertical
      }
      businessClient {
        id
        name
      }
      businessSite {
        id
        name
      }
      businessCustomer {
        id
      }
      photo {
        name
        path
      }
    }
  }
`

export const GET_PLACES_SUGGESTIONS = gql`
  query GetPlacesSuggestions($input: TPlaceSuggestionsInput!) {
    tplaceSuggestions(input: $input) {
      items {
        id
        name
        stateCode
        location {
          latitude
          longitude
        }
      }
    }
  }
`

export const GET_PLACES_AREA = gql`
  query GetPlacesArea($pagination: PaginationV2) {
    tplaces(pagination: $pagination) {
      items {
        id
        area
      }
    }
  }
`

export const GET_PLACES = gql`
  query GetPlaces($input: TPlacesInput, $pagination: PaginationV2) {
    tplaces(input: $input, pagination: $pagination) {
      total
      items {
        id
        name
        stateCode
        countryCode
        tags
        code
        parent {
          id
          name
        }
        businessClient {
          id
          name
        }
        businessSite {
          id
          name
        }
      }
    }
  }
`
